export class ConfigsDto {
  backOfficeQuotationEnabled: boolean;
  backOfficeQuotationUrls: string | null;
  partnerHubQuotationEnabled: boolean;
  partnerHubQuotationUrls: string | null;
  fxTradeQuotationEnabled: boolean;
  fxTradeQuotationUrls: string | null;
  massPaymentQuotationEnabled: boolean;
  massPaymentQuotationUrls: string | null;
}
